import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Events } from 'ionic-angular';

@Component({
  selector: 'page-newRating',
  templateUrl: 'newRating.html'
})

export class NewRatingPage {

  newName: string = "";

  constructor(public navCtrl: NavController, public events: Events) {
  }

  saveRating(event) {
    console.log("Save Rating: " + this.newName);

    if (this.newName > "") {
      console.log("Sending ratings:new event");
      this.events.publish('ratings:add', this.newName);
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/newRating/newRating.ts